import _ from 'lodash';
import fontFamiliesBase from './fontFamiliesBase';

export const fontFamily = 'Helvetica Now Text SA, Helvetica Neue, Helvetica, Arial, sans-serif';

const fontFamilies = _.mapValues(fontFamiliesBase, family => ({ ...family, fontFamily }));

export default fontFamilies;